module.exports = __webpack_public_path__ + "img/potential-time-savings.2800184a.png";